/* eslint-disable jquery/no-text */
import $ from 'jquery';
import moment from 'moment-timezone';
import PropTypes from 'prop-types';
import { Component } from 'react';
import { Link } from 'react-router-dom';

import withDefaultAppContexts from 'hb-react/frontoffice/contexts/withDefaultAppContexts';
import NetworkLink from 'hb-react/shared/components/NetworkLink';
import { completeName } from 'helpers/name';

import style from './index.module.scss';

class LinkedEvent extends Component {
  componentDidMount() {
    $(this.eventTitle).text((index, origText) =>
      AlumniConnect.Helpers.Global.truncate(origText, 90),
    );
  }

  renderAttendees = () => {
    const { id, total_attendees: totalAttendees } = this.props;
    const attendees = this.props.attendees.map((attendee) => (
      <li key={attendee.id}>
        <Link to={Routes.user_path(attendee.id)}>
          <img
            src={attendee.photo_thumb_url}
            alt="event attendee profile picture"
            title={completeName(attendee)}
          />
        </Link>
      </li>
    ));

    if (attendees.length === 6 && totalAttendees > 6) {
      attendees.push(
        <li className="users-listing__total" key={`${id}_and_more`}>
          <i>+ {totalAttendees - attendees.length}</i>
        </li>,
      );
    }

    return attendees;
  };

  render() {
    const {
      id,
      title,
      photo_thumb_url: photoThumbUrl,
      start_date: startDate,
      timezone,
      currentUser,
    } = this.props;

    const linkedEventPath = currentUser
      ? Routes.network_events_event_path(id)
      : Routes.network_event_path(id);

    return (
      <NetworkLink
        className={`flexbox push-quarter--bottom palm--push-half--bottom ${style.component}`}
        to={linkedEventPath}
        forceDefaultLink={!currentUser}
      >
        <div className="grid__item one-eighth palm--one-quarter hard v-top">
          <img
            className="user-item__img user-item__img--50 img-fit--cover"
            src={photoThumbUrl}
          />
        </div>
        <div className="grid__item seven-eighths palm--three-quarters v-top soft-half--left">
          <div
            ref={(ref) => (this.eventTitle = ref)}
            className={`h5 weight--semibold color-dark-gray inline-block flush ${style.title}`}
            title={title}
          >
            {title}
          </div>
          <div className="color-gray f-size--0-9 line-height-1-5">
            <div className="soft-quarter--ends">
              {moment.tz(startDate, timezone).format('LL')}
            </div>
            <ul className="users-listing__user">{this.renderAttendees()}</ul>
          </div>
        </div>
      </NetworkLink>
    );
  }
}

LinkedEvent.propTypes = {
  attendees: PropTypes.array,
};

LinkedEvent.defaultProps = {
  attendees: [],
};

export default withDefaultAppContexts(LinkedEvent);
